import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef } from "@angular/core";
import { delay } from '../../../shared';
import { ResearchCard } from '../../shared';
import Editor from '@toast-ui/editor';


@Component({
    selector: 'app-research-card-edit',
    templateUrl: "./research-card-edit.component.html",
    styleUrls: ["./research-card-edit.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ResearchCardEditComponent implements OnInit {
    @Input() card: ResearchCard;
    summaryEditor: Editor;
    showTitleDe: boolean = false;


    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    get formTopContent() {
        if (document.getElementById("form-top-content")) {
            return document.getElementById("form-top-content").clientHeight;
        } else {
            return 100;
        }
    }

    get textEditorHeight() {
        const height = this.jsPanelContentHeight - this.formTopContent - 85;
        return height < 200 ? 200 : height;
    }

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.initializeSummaryEditor();
        if (this.card.title_de) {
            this.showTitleDe = true;
        }
    }

    async initializeSummaryEditor() {
        await delay(100);
        this.cd.detectChanges();
        await delay(100);

        this.summaryEditor = new Editor({
            el: document.querySelector('#tuiSummaryEditor'),
            minHeight: '200px',
            height: `${this.textEditorHeight}px`,
            initialValue: this.card.abstract,
            initialEditType: 'wysiwyg',
            hideModeSwitch: true,
            toolbarItems: [
                ['heading', 'bold', 'italic', 'strike'],
                ['hr', 'quote'],
                ['ul', 'ol'],
                ['link'],
                ['code', 'codeblock']
            ]
        });
    }

    fnUpdateEditorHeight() {
        if (this.summaryEditor) {
            this.summaryEditor.setHeight(`${this.textEditorHeight}px`);
        }
    }

}
